import React, { useMemo } from 'react';
import { ThemeProvider as _ThemeProvider } from 'styled-components';
import onlineTheme from './online';

interface IThemeProviderProps {
  theme?: any;
}

const ThemeProvider: React.FC<IThemeProviderProps> = ({ children, theme = onlineTheme }) => {
  return <_ThemeProvider theme={theme}>{children}</_ThemeProvider>;
};

export default ThemeProvider;
